"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.notificationsTemplateExtractor = exports.defaultExtractor = void 0;
var defaultExtractor = function (response) { return response; };
exports.defaultExtractor = defaultExtractor;
var notificationsTemplateExtractor = function (response) {
    return response.notification_templates;
};
exports.notificationsTemplateExtractor = notificationsTemplateExtractor;
//# sourceMappingURL=NotificationTemplate.consts.js.map